module.exports = __webpack_public_path__ + "static/media/App icon Tasty.33f69882.png";